export default __webpack_public_path__ + "static/media/echoAR.4b8bc90d.png";